<template>
  <div class="commission-ladder">
    <div
      v-for="item in levels"
      :key="item.level"
      class="commission-ladder__item"
      :class="{ 'commission-ladder__item--locked': locked }"
    >
      <div class="commission-ladder__level">N{{ item.level }}</div>
      <div class="commission-ladder__info">
        <span class="commission-ladder__label">{{ item.label }}</span>
        <span v-if="showReceived" class="commission-ladder__received">
          Recebido: {{ formatCurrency(receivedByLevel[item.level] || 0) }}
        </span>
      </div>
      <div class="commission-ladder__value">
        <v-icon v-if="locked" small color="#9e9e9e">mdi-lock</v-icon>
        {{ formatCurrency(item.value) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  PREMIUM_COMMISSION_LEVELS,
  formatPremiumCurrency,
} from "@/config/premiumProgram";
import { defineComponent } from "vue";

export default defineComponent({
  name: "PremiumCommissionLadder",
  props: {
    locked: { type: Boolean, default: false },
    showReceived: { type: Boolean, default: false },
    receivedByLevel: {
      type: Object as () => Record<number, number>,
      default: () => ({}),
    },
  },
  setup() {
    return {
      levels: PREMIUM_COMMISSION_LEVELS,
      formatCurrency: formatPremiumCurrency,
    };
  },
});
</script>

<style scoped lang="scss">
.commission-ladder {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.commission-ladder__item {
  display: grid;
  grid-template-columns: 44px 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 10px;
  background: linear-gradient(90deg, rgba(229, 24, 61, 0.06), #fff 60%);
  border: 1px solid rgba(229, 24, 61, 0.12);
}
.commission-ladder__item--locked {
  opacity: 0.72;
  background: #f5f5f5;
  border-color: #e0e0e0;
}
.commission-ladder__level {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e5183d;
  color: #fff;
  font-weight: 800;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.commission-ladder__item--locked .commission-ladder__level {
  background: #bdbdbd;
}
.commission-ladder__label {
  display: block;
  font-weight: 600;
  font-size: 0.85rem;
  color: #1a1a2e;
}
.commission-ladder__received {
  display: block;
  font-size: 0.75rem;
  color: #1b7d42;
  margin-top: 2px;
}
.commission-ladder__value {
  font-weight: 700;
  font-size: 0.95rem;
  color: #e5183d;
  display: flex;
  align-items: center;
  gap: 4px;
}
.commission-ladder__item--locked .commission-ladder__value {
  color: #757575;
}
</style>
